import React from 'react';

export type Props = {
  name: string;
};

export const AtomWrapper: React.FC<React.PropsWithChildren<Props>> = ({ name, children }) => (
  <div style={{ width: '100%' }} data-test={`${name}-field-control`} className="field-control">
    <div data-test={`${name}-field-wrapper`}>{children}</div>
  </div>
);
